import * as React from 'react'
import { FormControl, IconButton } from '@mui/material'
import { OutlinedInput as MUIOutlinedInput } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'

import { Eye, EyeOff } from 'lucide-react'

import * as styles from './OutlinedInput.module.scss'

export const OutlinedInput = ({
  name,
  register,
  label,
  inputType,
  error,
  required,
  disabled,
}) => {
  const [type, setType] = React.useState(inputType)

  const handleClickShowPassword = () => {
    setType(type === 'password' ? 'text' : 'password')
  }

  const endAdornment =
    inputType === 'password' ? (
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        edge="end"
        size="small"
      >
        {type === 'password' ? <Eye /> : <EyeOff />}
      </IconButton>
    ) : null

  return (
    <FormControl className={styles.control} fullWidth>
      <InputLabel
        shrink
        className={styles.label}
        variant="outlined"
        required={required}
        htmlFor={name}
        classes={{
          focused: !error ? styles.labelFocused : styles.labelFocusedError,
          asterisk: styles.asterisk,
        }}
      >
        {label}
      </InputLabel>
      <MUIOutlinedInput
        required={required}
        {...register(name, { required: required })}
        type={type}
        classes={{
          focused: !error && styles.focusTest,
          notchedOutline: styles.notchedOutline,
        }}
        label={label}
        notched
        id={name}
        aria-describedby={name}
        error={!!error}
        disabled={disabled}
        endAdornment={endAdornment}
      />
      {error && (
        <FormHelperText error={!!error} id={name}>
          {error && error.message}
        </FormHelperText>
      )}
    </FormControl>
  )
}
